import { render, staticRenderFns } from "./ShopPlatformManager.vue?vue&type=template&id=91a26c78&scoped=true&lang=pug&"
import script from "./ShopPlatformManager.vue?vue&type=script&lang=ts&"
export * from "./ShopPlatformManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a26c78",
  null
  
)

export default component.exports